export const MUESTRA_ESTADOS = [
  "catalogado",
  "no_pedido",
  "pendiente_llegar",
  "llegado",
];

export const muestraEstadoColor = (estado) => {
  switch (estado) {
    case "pendiente_llegar":
      return "#ef6c00";
    case "llegado":
      return "#2e7d32";
    case "no_pedido":
      return "#546e7a";
    case "catalogado":
      return "#5e35b1";
    default:
      return "#78909c";
  }
};

/** Primera foto del material (galería o legado FotoArchivo). */
export const materialPrimaryFotoArchivo = (material) => {
  if (!material) return null;
  const fromGallery = Array.isArray(material.Fotos)
    ? material.Fotos.find((f) => f?.Archivo)?.Archivo
    : null;
  return fromGallery || material.FotoArchivo || null;
};

export const formatFeriaLabel = (row) => {
  if (!row) return "";
  const temporada = row.Temporada ? ` ${row.Temporada}` : "";
  const nombre = row.NombreFeria || row.Nombre || "";
  const anio = row.Anio ? ` ${row.Anio}` : "";
  return `${nombre}${anio}${temporada}`.trim();
};
